// extracted by mini-css-extract-plugin
export default {"title":"title-module__title__5zLCv"};